/**
 * Swiper component
 */
import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
Swiper.use([Autoplay]);
var el = document.querySelector('div[data-slideshow]');
var settings = JSON.parse(el.dataset.slideshow);
var swiper = new Swiper(el, settings);
swiper.init();
